<template>
  <div class="executor-card flex-wrap"  :style="`${executing?'':'animation:none;'};${error?'background:var(--error);':(success?'background:var(--success);':'')}`">
    <BaseIcon v-if="icon" :icon="icon" :size="15" style="margin-right:5px;" />
   
    <div class="executor-content">
        <div style="color:var(--hover-text);margin-right:5px;color:#ffe;font-size:10px;" v-if="!message.loading && message.actionName">工具调用 - {{message.actionName}}</div>
        {{  message.loading?'工具加载中':content }}
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            executing:false,
            content:'',
            success:false,
            error:null,
            toExecute:false
        }
    },
    watch:{
        message:{
            handler(m){
                if(m.toExecute && !this.toExecute){
                    this.toExecute = true
                    this.execute()
                }
            },
            deep:true
        }
    },
    props:{
        message:{
            type:Object,
            default:()=>({})
        }
    },
    computed:{
        icon(){
            if(this.error){
                return 'md-close-circle'
            }else if(this.success){
                return 'md-checkmark-circle'
            }else if(this.executing){
                return 'md-loading'
            }
        }
    },
    methods:{
        execute(){
            let tools = {
                route:(path,callback)=>{
                    if(path == this.$route.path){
                        this.content = '已经在此页面了，无需跳转'
                    }else{
                         this.content = '正在为您跳转'
                        this.RouteTo(path)

                    }
                   
                    callback()
                }
            }

            let message = this.message
            try{
                let tool = tools[message.actionName]
                if(tool){
                    this.executing = true
                    tool(message.params,()=>{
                        this.executing = false
                        this.content = '跳转成功'
                        this.success = true
                    })
                }else{
                    this.content = `工具{${message.actionName}}不存在`
                    this.error = true
                }
            }catch(e){
                this.executing = false
                this.content = e.message
                this.error = true
            }
           
        }
    }
}
</script>

<style lang="less">
.executor-card{
    padding:2px 5px;
    border-radius: 5px;
    background: linear-gradient(270deg, #42d392, #647eff, #e390d6, #42d392);
    background-size: 600% 600%;
    animation: executor-gradient-bg 3s ease infinite;
    color: #fff;
    transition: background 0.3s;

    &.executing {
        animation-play-state: running;
    }
}
@keyframes executor-gradient-bg {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

</style>